import { Drawer as AntdDrawer } from 'antd';
import { IoCloseOutline } from '@common-web/icon/icons';
import styles from './index.module.scss';

const Sidebar = ({
  setSidebarOpen = () => {},
  sidebarOpen = false,
  placement = 'right',
  content = '',
  title = true,
  closeIcon = false,
  heading = '',
  description = '',
  sidebarWidth = 450,
  footer,
  loading = false,
}) => {
  return (
    <AntdDrawer
      placement={placement}
      width={sidebarWidth}
      open={sidebarOpen}
      loading={loading}
      onClose={() => setSidebarOpen(false)}
      footer={footer}
      className={''}
      title={
        title && (
          <>
            {heading && <div className={styles.sidebarHeading}>{heading}</div>}
            {description && <div className={styles.sidebarDesc}>{description}</div>}
          </>
        )
      }
      extra={
        <IoCloseOutline color="#9D9D9D" size={24} style={{ cursor: 'pointer' }} onClick={() => setSidebarOpen(false)} />
      }
      closeIcon={closeIcon}
    >
      {content}
    </AntdDrawer>
  );
};

export default Sidebar;
